// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"159":"09d464e4","299":"1507a7a6","511":"1bda4448","681":"25b20ec5","810":"7c76d233","845":"b1f9568a","876":"58a196f3"}[chunkId] + ".chunk.js";
};